import React from 'react';
import { useRoom } from '../context/RoomContext';
import { useAuth } from '../context/AuthContext';
import './ScreenShareNotification.css';

const ScreenShareNotification = () => {
  const { screenShareRequests, approveScreenShare, denyScreenShare, room, socketId } = useRoom();
  const { user } = useAuth();
  
  // Check if current user is the host
  const isHost = user && room && (room.hostId === socketId);
  
  // Don't show if not host or no requests
  if (!isHost || screenShareRequests.length === 0) {
    return null;
  }

  return (
    <div className="screen-share-notifications">
      {screenShareRequests.map(request => (
        <div key={request.participantId} className="screen-share-notification">
          <div className="notification-content">
            <span className="notification-icon">🖥️</span>
            <span className="notification-text">
              <strong>{request.participantName}</strong> demande à partager son écran
            </span>
          </div>
          <div className="notification-actions">
            <button
              className="notification-btn approve"
              onClick={() => approveScreenShare(request.participantId)}
            >
              Approuver
            </button>
            <button
              className="notification-btn deny"
              onClick={() => denyScreenShare(request.participantId)}
            >
              Refuser
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ScreenShareNotification;
